import Swiper from '../../node_modules/swiper/js/swiper';


new Swiper('.swiper-vendors', {

  slidesPerView: 'auto',
  spaceBetween: 10,
  loop: true,

  breakpoints: {
    // when window width is >= 768px
    768: {
      spaceBetween: 13,
      centeredSlides: true,
    },
  },

  navigation: {
    nextEl: '.swiper-button-next-vendors',
    prevEl: '.swiper-button-prev-vendors',
  },
});
